/* eslint-disable no-restricted-syntax */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useRef, useEffect } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Ring } from "react-awesome-spinners";
import GameLogActions from "./GameLogActions";
import {
  X,
  WhiteMan as WhiteSource,
  RedMan as RedSource,
  GreenMan as GreenSource,
} from "../../Constants/assets";

// Stylings
const InnerContainer = styled.div`
  position: absolute;
  z-index: 1;
  width: 40%;
  height: 70%;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  transform: translate(0%, 4%);

  @media (max-height: 800px) {
    height: 90%;
  }
`;
const CenterAllContainer = styled.div`
  width: 92%;
  height: 88%;
  margin: 35px auto;
`;
const HeaderContainer = styled.div`
  width: 99%;
  height: 23%;
`;
const Header = styled.h1`
  font-weight: bold;
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 40%;
`;
const ParagraphContainer = styled.div`
  height: 40%;
`;
const BodyContainer = styled.div`
  height: 75%;
  overflow-y: auto;
`;
const RecoursesContainer = styled.span`
  margin-right: 10px;
`;
const TotalUsedContainer = styled.div`
  font-weight: bold;
  font-size: 15px;
  display: flex;
  margin-bottom: 7px;
  `;

export default function GameLog({
  showGameLog,
  gameLogToggle,
  data,
  position,
  positionGameLog,
  getLastMilestoneTileId,
  isGamePaused,
  gameLogLoading,
  tasksArray,
  totalUsed,
}) {
  const [isLoading, setisLoading] = useState(true);
  const data1 = useRef();
  const [JSONData, setJSONData] = useState([]);
  const { t } = useTranslation();

  if (!showGameLog) return null;

  // const getthisData = isLoading ? myData() : null;
  return (
    <InnerContainer>
      <CenterAllContainer>
        {" "}
        <HeaderContainer>
          <Header>
            {t('modals.game_log.info_title')}
            <X
              style={{ cursor: "pointer" }}
              onClick={() => {
                gameLogToggle(false);
                setisLoading(false);
              }}
            />
          </Header>
          <ParagraphContainer>
            <TotalUsedContainer>
              <div style={{ marginRight: "25px" }}>{t('modals.game_log.budget_used')}: ${totalUsed.budgetUsed}</div>
              <div>
                {t('modals.game_log.resources_used')}
                <RecoursesContainer>
                  <WhiteSource />
                  {totalUsed.regular}
                </RecoursesContainer>
                <RecoursesContainer>

                  <RedSource />
                  {totalUsed.senior}
                </RecoursesContainer>
                <RecoursesContainer>

                  <GreenSource />
                  {totalUsed.expensive}
                </RecoursesContainer>

              </div>
            </TotalUsedContainer>
            <div>{t('modals.game_log.info_text')}</div>
          </ParagraphContainer>
        </HeaderContainer>
        <BodyContainer>
          {data?.length > 0 &&
            data?.map((current, index) => {
              if (!data[index]?.turnData) {
                return;
              }
              if (data[index].cardData === null) return;
              const positionIndex = index;
              const isLast = index === data.length - 1;
              // console.log('code before', data[index].code);
              return (
                <GameLogActions
                  data={data[index]}
                  position={position}
                  positionGameLog={positionGameLog}
                  key={index}
                  positionIndex={positionIndex}
                  {...current}
                  isLast={isLast}
                  getLastMilestoneTileId={getLastMilestoneTileId}
                  isGamePaused={isGamePaused}
                  gameLogLoading={gameLogLoading}
                  tasksArray={tasksArray}
                />
              );
            })}
          {gameLogLoading ? (
            <div
              style={{
                justifyContent: "center",
                display: "flex",
              }}
            >
              <Ring size="50" />
            </div>
          ) : null}
        </BodyContainer>
      </CenterAllContainer>
    </InnerContainer>
  );
}

// gameLogLoading ? : null
